// Black Friday – läuft nur, wenn snippets/black-friday.liquid eine Phase gesetzt hat.
// Early Access: Band mit Code und Prozent-Ersparnis auf allen Produkten (außer Sets).
// Öffentlich: Band mit Ersparnis aus dem Streichpreis; am Tagesdeal-Tag für Produkte
// der Deal-Kategorie mit Deal-Text und Countdown bis Mitternacht.
(function () {
  var info = window.pnyBlackFriday;
  if (!info || !info.phase || info.excluded || !window.pnyCampaignBand) return;

  var early = info.phase === 'early';
  window.pnyCampaignBand({
    icon: '🩷',
    title: early ? 'Ponyclub Early Access' : info.deal ? info.dealText : info.title,
    endDay: info.deal ? info.today : info.end,
    savings: early ? 'percent' : 'compare',
    percent: info.percent,
    code: early ? info.code : '',
    colors: { bg: '#000', pillBg: info.accent, pillFg: '#fff', muted: '#bbb', accent: info.accent }
  });
})();
